<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="0"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <!-- 2.goodsTitle-container-end -->

    <!-- 3. -container-start -->
    <div class="main">
      <div class="center borderShadow">
        <div class="left borderShadow">
          <img
            v-if="currentPageInfo.pc_img"
            :src="currentPageInfo.pc_img"
            alt=""
            class="img"
          />
        </div>
        <div class="right">
          <div v-if="currentPageInfo.goods_name" class="line flexStyle2">
            <div class="left">商品名称:</div>
            <div class="right">
              {{ currentPageInfo.goods_name || "暂无商品名称" }}
            </div>
          </div>
          <div v-if="currentPageInfo.weight" class="line flexStyle2">
            <div class="left">商品重量:</div>
            <div class="right">
              {{ currentPageInfo.weight || "暂无商品重量" }}kg
            </div>
          </div>
          <div v-if="currentPageInfo.volume" class="line flexStyle2">
            <div class="left">商品体积:</div>
            <div class="right">
              {{ currentPageInfo.volume || "暂无商品体积" }}
            </div>
          </div>
          <div v-if="currentPageInfo.goods_code" class="line flexStyle2">
            <div class="left">商品编号:</div>
            <div class="right">
              {{ currentPageInfo.goods_code || "暂无商品编号" }}
            </div>
          </div>
          <div v-if="currentPageInfo.pc_detail" class="line line2 flexStyle2">
            <div class="left">商品描述:</div>
            <div class="html" v-html="currentPageInfo.pc_detail"></div>
          </div>
        </div>
        <div @click="goBack" class="goBack c-animation hands">返回</div>
      </div>
    </div>
    <!-- 3.main-container-end -->

    <!-- 4.goodsFooter-container-start -->
    <!-- <goods-footer class="footer"></goods-footer> -->
    <c-footer></c-footer>
    <!-- 4.goodsFooter-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
// import goodsTitle from "../../components/goodsTitle/goodsTitle";
// import goodsFooter from "../../components/goodsFooter/goodsFooter";
import { goodsDetailRequest } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      token: "", // 1.2.token
      sysId: "", // 1.3.sysId
      setmealId: "", // 1.4.setmealId
      goodId: "", // 1.5.goodId
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter
    tabbar,
    cFooter: footer,
  },

  methods: {
    // 3.methods
    getGoodsDetailInfo() {
      // 3.1.获取商品详情
      let data = {
        goodId: this.goodId,
        setmealId: this.setmealId,
        sysId: this.sysId,
      };

      goodsDetailRequest(data).then((res) => {
        if (res) {
          this.currentPageInfo = res.data[0];
        }
      });
    },

    goBack() {
      // 3.2.返回
      this.$router.go(-1);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
    this.token = res.token;
    this.setmealId = res.setmealId;
    this.goodId = res.goodId;
    this.getGoodsDetailInfo();
  },
};
</script>

<style scoped lang="scss">
@import "./goodsDetail.scss";
</style>